import React, { useEffect, useState } from "react";
import { useField } from "formik";
import { Box, Button, FormControl } from "@mui/material";
import { CheckboxProps } from "@mui/material/Checkbox";
import { CheckboxField, ValidationMessages } from "./index";
import LayersIcon from '@mui/icons-material/Layers';
import LayersClearIcon from '@mui/icons-material/LayersClear';
import { useTranslation } from "react-i18next";
import { map } from "lodash";

export interface CheckboxMultipleFormikProps
    extends Omit<CheckboxProps, "name" | "onChange" | "onBlur" | "error"> {
    id: string;
    options: any;
    status?: boolean;
}

const CheckboxMultipleFormik = ({status, id, options, ...props}: CheckboxMultipleFormikProps) => {
    const [field, meta, helpers] = useField(id);
    const { t } = useTranslation();

    // const { value } = meta;
    const { setValue } = helpers;

    /**
     * Button action controller toggle select all form
     */
    const [isAllSelected, setAllSelected] = useState<boolean>(false)
    const [valueOptions, setValueOptions] = useState<any>(options?.choices || [])

    /**
     *  This function is used to select all values and save it to field value
     */
    const handleSelectAll = () => {
        if (!valueOptions) return

        let allValues: any = []
        if (!isAllSelected) {
            for (const option of Object.entries(valueOptions)) {
                allValues.push(String(option[1]))
            }
        }

        // set all values to field
        setValue(allValues)
    }

    /**
     * This function listen status of form and change state of isAllSelected flag
     */
    const checkSelectedValues = () => {
        if (!field.value) return

        if (field.value.length === Object.entries(valueOptions).length) {
            setAllSelected(true)
        } else {
            setAllSelected(false)
        }
    }

    useEffect(() => {
        checkSelectedValues()
    }, [field.value])

    return (
        <>
            {(Object.keys(options.choices).length > 1) &&
              <Button
                disabled={status}
                startIcon={isAllSelected ? <LayersClearIcon/> : <LayersIcon/>}
                onClick={(() => handleSelectAll())}
                color={'primary'}
              >
                {isAllSelected ? t('unselect-all') : t('select-all')}
              </Button>
            }
            <Box mt={1}>
              <FormControl fullWidth error={meta.touched && Boolean(meta.error)} component="fieldset">
                {map(valueOptions, (option, key) =>
                    <CheckboxField
                        status={status}
                        key={String(option)}
                        name={id}
                        label={key}
                        value={String(option)}
                    />
                )}
                <ValidationMessages meta={meta} />
              </FormControl>
            </Box>
        </>
    )
};

export default CheckboxMultipleFormik;
